import * as React from 'react';
import { useSelector } from 'react-redux';

import { SeoMarkedListPlaceholder } from '../../components/SeoMarkedList/components/SeoMarkedListPlaceholder';
import { getMarkedListItems } from '../../selectors/seo';

export const SeoMarkedListPlaceholderContainer: React.FC = () => {
  const [isMounted, setIsMounted] = React.useState(false);
  const markedListItems = useSelector(getMarkedListItems);
  const visibleItemsCount = markedListItems.filter(item => !item.underH1).length;

  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  if (isMounted || visibleItemsCount === 0) {
    return null;
  }

  return <SeoMarkedListPlaceholder itemsCount={visibleItemsCount} />;
};
